import {
  AfterContentInit,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { SelectOption } from 'src/app/types';

@Component({
  selector: 'app-step2-event-location-form',
  templateUrl: './step2-event-location-form.component.html',
})
export class Step2EventLocationFormComponent
  implements OnInit, AfterContentInit
{
  @Output() eventLocationFormValid: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() stepLoaded: EventEmitter<void> =
    new EventEmitter<void>();

  //TODO: Replace with translationKeys
  testFormOptions: SelectOption[] = [
    {
      value: 'testzentrum',
      label: 'Testzentrum',
    },
    {
      value: 'proctoring',
      label: 'Online',
    },
  ];

  private form!: UntypedFormGroup;

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      testForm: ['', Validators.required],
    });

    this.form.valueChanges.subscribe((_value) => {
      this.eventLocationFormValid.emit(this.form.valid);
    });
  }

  ngAfterContentInit() {
    this.stepLoaded.emit();
  }

  async submit(): Promise<boolean> {
    this.form.markAllAsTouched();
    return this.form.valid;
  }

  get testForm(): UntypedFormControl {
    return this.form.get('testForm') as UntypedFormControl;
  }
}
